import React from 'react';
import { FooterStyles } from './footerstyles';

export default function Footer() {
  return (
    <FooterStyles>
      <div>
        Note: Percentages are based on assessed fish stocks and may not be
        directly comparable across regions due to differences in assessment
        coverage. Percentages may not sum to 100 due to rounding.
        <br />
        Source: The State of World Fisheries and Aquaculture 2026
      </div>
    </FooterStyles>
  );
}
